angular.module('ngWig')
    .config(['ngWigToolbarProvider', function (ngWigToolbarProvider) {
       ngWigToolbarProvider.addCustomButton('vars', 'nw-vars-button');
    }])
    .component('nwVarsButton', {
        bindings: {
            content: '=',
            execCommand: '=',
            editMode: '=',
            disabled: '='
        },
        template: `<select class="nw-select" 
                           ng-model="$ctrl.var" 
                           ng-change="$ctrl.addVar($ctrl.var)" 
                           ng-options="var.name group by var.cat for var in $ctrl.vars" 
                           ng-disabled="$ctrl.editMode || $ctrl.disabled">
            <option value="">Add a variable</option>
        </select>`,
        controller: function($mdDialog, $http, Upload, appUtils) {
            var main = this;
            main.vars = [
                {'name': 'Franchise Name', 'raw': '*|FRANCHISE_NAME|*', 'cat': 'Global'},
                {'name': 'Franchise Owner Name', 'raw': '*|FRANCHISE_OWNER_NAME|*', 'cat': 'Global'},
                {'name': 'Franchise Email', 'raw': '*|FRANCHISE_EMAIL|*', 'cat': 'Global'},
                {'name': 'Franchise Phone', 'raw': '*|FRANCHISE_PHONE|*', 'cat': 'Global'},
                {'name': 'Franchise Signature', 'raw': '*|FRANCHISE_SIGNATURE|*', 'cat': 'Global'},
                {'name': 'School Director', 'raw': '*|SCHOOL_DIRECTOR|*', 'cat': 'Event'},
                {'name': 'Event Name', 'raw': '*|EVENT_NAME|*', 'cat': 'Event'},
                {'name': 'School Name', 'raw': '*|SCHOOL_NAME|*', 'cat': 'Event'},
                {'name': 'Signup Link', 'raw': '*|SIGNUP_LINK|*', 'cat': 'Event'},
                {'name': 'Director Link', 'raw': '*|DIRECTOR_LINK|*', 'cat': 'Event'},
                {'name': 'Director Unviewed Link', 'raw': '*|DIRECTOR_UNVIEWED_LINK|*', 'cat': 'Event'},
                {'name': 'Contact Handout Link', 'raw': '*|CONTACT_HANDOUT_LINK|*', 'cat': 'Event'},
                {'name': 'Contact Handout Unviewed Link', 'raw': '*|CONTACT_HANDOUT_UNVIEWED|*', 'cat': 'Event'},
                {'name': 'Event Has Unviewed Galleries', 'raw': '', 'cat': 'Event'},
                {'name': 'Event Allows School Shipping', 'raw': '', 'cat': 'Event'},
                {'name': 'Blog Link', 'raw': '*|BLOG_LINK|*', 'cat': 'Event'},
                {'name': 'Marketing PDF', 'raw': '*|MARKETING_PDF|*', 'cat': 'Event'},
                {'name': 'Photographer Link', 'raw': '*|PHOTOGRAPHER_LINK|*', 'cat': 'Event'},
                {'name': 'Number of Subjects for Marketing Materials', 'raw': '*|NUM_SUBJ_MARKETING|*', 'cat': 'Event'},
                {'name': 'Total Posters Needed', 'raw': '*|TOTAL_POSTERS_NEEDED|*', 'cat': 'Event'},
                {'name': 'Contact First Name', 'raw': '*|CONTACT_FIRST_NAME|*', 'cat': 'Global'},
                {'name': 'Contact Last Name', 'raw': '*|CONTACT_LAST_NAME|*', 'cat': 'Global'},
                {'name': 'Subject First Name', 'raw': '*|SUBJECT_FIRST_NAME|*', 'cat': 'Global'},
                {'name': 'Subject Last Name', 'raw': '*|SUBJECT_LAST_NAME|*', 'cat': 'Global'},
                {'name': 'Subject Notes', 'raw': '*|SUBJECT_NOTES|*', 'cat': 'Global'},
                {'name': 'Subject Photo Day', 'raw': '*|PHOTO_DAY|*', 'cat': 'Global'},
                {'name': 'Subject Has Photo Day', 'raw': '', 'cat': 'Global'},
                {'name': 'Class Name', 'raw': '*|CLASS_NAME|*', 'cat': 'Global'},
                {'name': 'Teacher Name', 'raw': '*|TEACHER_NAME|*', 'cat': 'Global'},
                {'name': 'Late Orders Close Date', 'raw': '*|LATE_ORDERS_CLOSE_DATE|*', 'cat': 'Dates'},
                {'name': 'Marketing Due Date', 'raw': '*|MARKETING_DUE_DATE|*', 'cat': 'Dates'},
                {'name': 'Second Flyer Due Date', 'raw': '*|SECOND_FLYER_DUE_DATE|*', 'cat': 'Dates'},
                {'name': 'Final Electronic Reminder Date', 'raw': '*|SEND_FINAL_REMINDER|*', 'cat': 'Dates'},
                {'name': 'Orders Due Today or Tomorrow', 'raw': '*|DUE_TODAY_OR_TOMORROW|*', 'cat': 'Dates'},
                {'name': 'Orders Due Date', 'raw': '*|ORDERS_DUE_DATE|*', 'cat': 'Dates'},
                {'name': 'Grace Period Ends', 'raw': '*|GRACE_PERIOD_ENDS|*', 'cat': 'Dates'},
                {'name': 'Start Date', 'raw': '*|START_DATE|*', 'cat': 'Dates'},
                {'name': 'End Date', 'raw': '*|END_DATE|*', 'cat': 'Dates'},
                {'name': 'Date Range', 'raw': '*|DATE_RANGE|*', 'cat': 'Dates'},
                {'name': 'Expected Delivery Date', 'raw': '*|EXPECTED_DELIVERY_DATE|*', 'cat': 'Dates'},
                {'name': 'Registration Signup Deadline', 'raw': '*|SIGNUP_DEADLINE|*', 'cat': 'Dates'},
                {'name': 'Slideshow URL', 'raw': '*|SLIDESHOW_URL|*', 'cat': 'Gallery'},
                {'name': 'Gallery URL', 'raw': '*|GALLERY_URL|*', 'cat': 'Gallery'},
                {'name': 'Yearbook URL', 'raw': '*|YEARBOOK_URL|*', 'cat': 'Gallery'},
                {'name': 'Access Code', 'raw': '*|ACCESS_CODE|*', 'cat': 'Gallery'},
                {'name': 'Ordered Survey Link', 'raw': '*|ORDERED_SURVEY_LINK|*', 'cat': 'Survey Links'},
                {'name': 'Non-Ordered Survey Link', 'raw': '*|NONORDERED_SURVEY_LINK|*', 'cat': 'Survey Links'},
                {'name': 'Access Code List', 'raw': '*|ACCESS_CODE_LIST|*', 'cat': 'Event Admin'},
                {'name': 'Signups List', 'raw': '*|SIGNUPS_LIST|*', 'cat': 'Event Admin'},
                {'name': 'Flex 1', 'raw': '*|FLEX_1|*', 'cat': 'Flex Variables'},
                {'name': 'Flex 2', 'raw': '*|FLEX_2|*', 'cat': 'Flex Variables'},
                {'name': 'Flex 3', 'raw': '*|FLEX_3|*', 'cat': 'Flex Variables'},
                {'name': 'Flex 4', 'raw': '*|FLEX_4|*', 'cat': 'Flex Variables'},
                {'name': 'Flex 5', 'raw': '*|FLEX_5|*', 'cat': 'Flex Variables'},
                {'name': 'Flex Custom', 'raw': '*|FLEX_|*', 'cat': 'Flex Variables'},
                {'name': 'Order id', 'raw': '*|ORDER_ID|*', 'cat': 'Order Variables'},
                {'name': 'Order Receipt URL', 'raw': '*|RECEIPT_URL|*', 'cat': 'Order Variables'},
                {'name': 'Order Invoice URL', 'raw': '*|INVOICE_URL|*', 'cat': 'Order Variables'},
                {'name': 'Order Has Digitals', 'raw': '', 'cat': 'Order Variables'},
            ];

            main.addVar = function(variable) {
                if(variable === null) {
                    return;
                }

                if(variable.name == 'Subject Has Photo Day') {
                    main.execCommand(
                        'insertHtml', 
                        '<div>*|IF:HAS_PHOTO_DAY=1|*</div><div>Photo Day Content Here</div><div>*|ELSE:|*</div><div>No photo day content here</div><div>*|END:IF|*</div>'
                    );
                }
                else if(variable.name == 'Event Has Unviewed Galleries') {
                    main.execCommand(
                        'insertHtml',
                        '<div>*|IF:HAS_UNVIEWED_GALLERIES=1|*</div><div>Unviewed gallery content here</div><div>*|ELSE:|*</div><div>No unviewed galleries content here</div><div>*|END:IF|*</div>'
                    );
                }
                else if(variable.name == 'Event Allows School Shipping') {
                    main.execCommand(
                        'insertHtml',
                        '<div>*|IF:SCHOOL_SHIP=1|*</div><div>School shipping content here</div><div>*|ELSE:|*</div><div>No school shipping content here</div><div>*|END:IF|*</div>'
                    );
                }
                else if(variable.name == 'Order Has Digitals') {
                    main.execCommand(
                        'insertHtml', 
                        '<div>*|IF:ORDER_HAS_DIGITALS=1|*</div><div>Digital Content Here</div><div>*|END:IF|*</div>'
                    );
                }
                else if(variable.name == 'Flex Custom') {
                    var name = prompt("Enter the custom variable name");
                    main.execCommand(
                        'insertText', 
                        '*|FLEX_' + name.toUpperCase() + '|*'
                    );
                } else {
                    main.execCommand('insertText', variable.raw);
                }
                main.var = null;
            }
        }
    });
